import React from 'react';
import Datelocale from "./UI/Datelocale";
import {useIntl} from "react-intl";
import Doclist from "./UI/Doclist";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";


const RepairItem = (props) => {
    const intl = useIntl();
    const status = {
        1: {title: intl.messages.new, bage: 'bg bg-danger', alert: 'alert mb-3 alert-danger'},
        2: {title: intl.messages.waiting, bage: 'bg bg-warning', alert: 'alert mb-3 alert-warning'},
        3: {title: intl.messages.in_work, bage: 'bg bg-info', alert: 'alert mb-3 alert-info'},
        4: {title: intl.messages.ready, bage: 'bg bg-success', alert: 'alert mb-3 alert-success'},
        5: {title: intl.messages.canceled, bage: 'bg bg-secondary', alert: 'alert mb-3 alert-secondary'}
    };
    const toNumber = (value) => Number.parseFloat(value) || 0;
    const craneCount = toNumber(props.repair.crane);
    const cranePrice = toNumber(props.repair.crane_price);
    const craneTotal = craneCount * cranePrice;
    const photoPrice = toNumber(props.repair.photo_price ?? props.repair.photo);
    const repairRows = Array.isArray(props.repair.rows) ? props.repair.rows : [];
    const repairTotal = repairRows.length
        ? repairRows.reduce((sum, repair) => sum + toNumber(repair.sum), 0)
        : toNumber(props.repair.repair);
    const total = repairTotal + craneTotal + photoPrice;
    const currency = props.repair.currency || '';

    return (
        <>
            <Row className={status[props.repair.status].alert}>
                <Col lg={4} sm={6} xs={12}>
                    <div>
                        <span className="text-muted">{intl.messages.container}:</span>
                        {props.repair.c_number} <span className={status[props.repair.status].bage}>{status[props.repair.status].title}</span>
                    </div>
                    <div>
                        <span className="text-muted">{intl.messages.created}:</span>
                        <Datelocale date={props.repair.created}/>
                    </div>
                    <div>
                        <span className="text-muted">{intl.messages.createdBy}:</span>
                        {props.repair.createUserName}
                    </div>
                    {props.repair.agreed_user_id > 0 ? (
                        <div>
                            <span className="text-muted">{intl.messages.agreed}:</span>
                            {props.repair.agreeUserName}
                        </div>
                    ) : null}
                </Col>

                <Col lg={4} sm={6} xs={12}>
                    {props.repair.type === 'insulation' ? (
                        <div>
                            <span className="text-muted">{props.repair.nom_text}</span> {props.repair.rrsum} ₽
                            <br/>
                            <span className="text-muted">{intl.messages.total}: </span> {props.repair.rrsum} ₽
                        </div>
                    ) : (
                        <div>
                            <div>
                                <span className="text-muted">{intl.messages.crane_operations}: </span>
                                {craneCount} × {cranePrice} {currency} = {craneTotal} {currency}
                            </div>
                            <div>
                                <span className="text-muted">{intl.messages.photographing}: </span>
                                {photoPrice} {currency}
                            </div>
                            {repairRows.map((repair, index) => (
                                <div key={`${props.repair.id}-${index}`}>
                                    <span className="text-muted">
                                        {localStorage.getItem('locale') === "ru-RU" ? repair.name : repair.eng}:&nbsp;
                                    </span>
                                    {repair.price} {currency} × {repair.amount} = {repair.sum} {currency}
                                </div>
                            ))}
                            <div>
                                <span className="text-muted">{intl.messages.total}: </span>
                                <strong>{total} {currency}</strong>
                            </div>
                        </div>
                    )}
                </Col>

                <Col lg={4} sm={6} xs={12}>
                    <div>
                        <Doclist photo={props.repair.photo}/>
                        <Badge
                            bg="info"
                            className="pointer"
                            data-id={props.repair.id}
                            data-number={props.repair.c_number}
                            onClick={props.downloadPhoto}
                        >
                            {intl.messages.download}
                        </Badge>
                    </div>
                    {props.repair.status === 4 ? (
                        <div>
                            <span className="text-muted">{intl.messages.ready_repair}:</span>
                            <Datelocale date={props.repair.completed_date}/>
                        </div>
                    ) : null}
                </Col>

                <Col lg={4} sm={6} xs={12}>
                    {props.repair.status === 2 ? (
                        <>
                            <button
                                className="btn btn-success"
                                data-id={props.repair.id}
                                data-number={props.repair.c_number}
                                onClick={props.acceptRepair}
                                type="button"
                            >
                                {intl.messages.accept}
                            </button>
                            <button
                                className="btn btn-danger mx-2"
                                data-id={props.repair.id}
                                data-number={props.repair.c_number}
                                onClick={props.deniedRepair}
                                type="button"
                            >
                                {intl.messages.refuse}
                            </button>
                        </>
                    ) : null}
                </Col>
            </Row>
        </>
    );
};

export default RepairItem;
